import {Routes, RouterModule} from "@angular/router";
import {ClassroomComponent} from "./Classroom/classroom.component";
import {FlowComponent} from "./Flow/flow.component";
import {AboutComponent} from "./Home/about.component";
import {HomeComponent} from "./Home/home.component";
import {NotificationComponent} from "./notification.component";
import {MemberComponent} from "./Member/member.component";
import {NewComponent} from "./news/new.component";
import {MemberLoginComponent} from "./Member/member-login.component";
import {SearchResultComponent} from "./Home/searchresult.component";
import {SearchResultComponent2} from "./Home/searchresult2.component";
import {newdetailComponent} from "./news/new-detail.component";
import {MemberAdminComponent} from "./Member/member-admin.component";
import {OrderAdminComponent} from "./order-admin.component";
import {UploadComponent} from "./upload.component";
import {NewUploadComponent} from "./news/new-upload.component";
import {Detail1Component} from "./news/detail/detail1.component";
import {Detail2Component} from "./news/detail/detail2.component";
import {Detail3Component} from "./news/detail/detail3.component";
import {Detail4Component} from "./news/detail/detail4.component";
import {Detail5Component} from "./news/detail/detail5.component";
import {Detail6Component} from "./news/detail/detail6.component";

import {ParameterComponent} from "./blade_parameter.component";
import {New2Component} from "./news/new2.component";
import {New3Component} from "./news/new3.component";
import {New4Component} from "./news/new4.component";
import {New5Component} from "./news/new5.component";
import {New6Component} from "./news/new6.component";
import {New7Component} from "./news/new7.component";
import {New8Component} from "./news/new8.component";
import {New9Component} from "./news/new9.component";
import {New10Component} from "./news/new10.component";

const APP_ROUTES:Routes=[
  {path: '', component: HomeComponent},
  {path: 'flow', component: FlowComponent},
  {path: 'about', component: AboutComponent},
  {path: 'member', component: MemberComponent},
  {path: 'new', component: NewComponent},
  {path: 'newdetail', component: newdetailComponent},
  {path: 'MemberLogin', component: MemberLoginComponent},
  {path: 'classroom', component: ClassroomComponent},
  {path: 'notification', component: NotificationComponent},
  {path: 'SearchResult',component:SearchResultComponent},
  {path: 'SearchResult2',component:SearchResultComponent2},
  {path: 'memberAdmin',component:MemberAdminComponent},
  {path: 'orderAdmin',component:OrderAdminComponent},
  {path:'upload',component:UploadComponent},
  {path:'newUpload',component:NewUploadComponent},
  {path:'detail1',component:Detail1Component},
  {path:'detail2',component:Detail2Component},
  {path:'detail3',component:Detail3Component},
  {path:'detail4',component:Detail4Component},
  {path:'detail5',component:Detail5Component},
  {path:'detail6',component:Detail6Component},
  
  {path:'parameter',component:ParameterComponent},
  {path:'new2',component:New2Component},
  {path:'new3',component:New3Component},
  {path:'new4',component:New4Component},
  {path:'new5',component:New5Component},
  {path:'new6',component:New6Component},
  {path:'new7',component:New7Component},
  {path:'new8',component:New8Component},
  {path:'new9',component:New9Component},
  {path:'new10',component:New10Component}



];

export const routing = RouterModule.forRoot(APP_ROUTES,{useHash: true});



// WEBPACK FOOTER //
// ./src/app/app.routing.ts